import { render, staticRenderFns } from "./InformaticaPrincipal.vue?vue&type=template&id=022502e2&"
import script from "./InformaticaPrincipal.vue?vue&type=script&lang=js&"
export * from "./InformaticaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports